const SUPPRESS_CONSOLE_LOGS = "true";
const appConfig = {
  suppressLogs: SUPPRESS_CONSOLE_LOGS === "true"
};
export default appConfig;
